import React from "react";

function ContactUs() {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy-in">
   

      <h2>Contact Us</h2>
      <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
    <p>Name: CGTHomes </p>
    <p>Email: info@cgthomes.com</p>
    <p>Company Email: support@cgthomes.com</p>
    <p>Company Address: Street No 3, DLF Cyber City Hyderabad, telengana</p>
    {/* <p>Phone: +919513280298</p> */}

      </div>
    </div>
  );
}

export default ContactUs;
